<template>
  <div id="app">
    <!-- <SpeedInsights></SpeedInsights> -->
    <router-view />
    <!-- This renders matched component -->
  </div>
</template>

<script>
// import { SpeedInsights } from '@vercel/speed-insights/vue';
export default {
  name: "App",
  components: {
    // SpeedInsights,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
